<template>
     <!-- 新增签约 -->
     <el-dialog title="签约" width="25%" :visible.sync="dialogVisible" :show-close="false" :close-on-click-modal="false" destroy-on-close>
        <el-form :model="unitObj" ref="unitForm" :rules="rules" size="small">
          <el-form-item label="单位" :inline="true" class="znk_form_item" prop="name">
            <el-input v-model="unitObj.name" :disabled="true" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="单位编码" :inline="true" class="znk_form_item" prop="code">
            <el-input v-model="unitObj.code" :disabled="true" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="纳税识别号" :inline="true" class="znk_form_item" prop="nsrsbh">
            <el-input v-model="unitObj.nsrsbh" :disabled="true" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="签约日期" :inline="true" class="znk_form_item" prop="signDate">
            <el-date-picker style="width: 100%;" v-model="unitObj.signDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="金额" :inline="true" class="znk_form_item" prop="amount">
            <el-input v-model="unitObj.amount" type="number" placeholder="金额" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="服务期间" :inline="true" class="znk_form_item" prop="dateArr">
            <el-date-picker v-model="unitObj.dateArr" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" style="width: 100%;" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="客户经理" :inline="true" class="znk_form_item" prop="manager">
            <el-input v-model="unitObj.manager" placeholder="客户经理" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="文件" :inline="true" class="znk_form_item">
            <el-upload drag action="api/baseService/uploadSignFile" :on-success="handleSuccessUpload"  multiple :limit="1">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeDialog">取 消</el-button>
          <el-button size="small" @click="saveSignFunc()" type="primary" :loading="loading">确 定</el-button>
        </div>
      </el-dialog>  
</template>

<script>
import { getInfo,storeAccountInfo } from "@/cookie";
import { Message,MessageBox } from 'element-ui';
import { editorAccount } from "@/api/account";

import { saveSignInfo } from "@/api/service";


export default {
  name: "ServiceSignDialog",
  props: {
    dialogVisible: false,
    unitInfo: null,
  },
  data(){
    return {
      rules: {
          signDate: [
              { required: true, message: '签约日期不能为空', trigger: 'blur' }
          ],
          dateArr: [
            { required: true, message: '服务期间不能为空', trigger: 'change' }
          ]
      },
      loading:false,

      unitObj: {
        name: '',
        code: '',
        manage : '',
        managePhone: '',
        nsrsbh: '',
        amount: null,
        dateArr: null,
        signDate: null,
        fileId: null
      }

    }
  },
  mounted(){
     
  },
  created() {

  },
  watch : {
      unitInfo(newVal,oldVal){
        this.unitObj = newVal;
      }
  },
  methods: {
    
    //打开新增用户弹窗
    closeDialog(){
      this.$emit('close');
    },


    //保存用户信息
    saveSignFunc(){
      let this_ = this;
      let param = {...this_.unitInfo}
      this_.loading = true;
      //服务期间
      if(param.dateArr != null && param.dateArr.length > 0){
         param.startTime = param.dateArr[0];
         param.endTime   = param.dateArr[1];
      }
      param.unitCode = param.code;
      //校验
      this.$refs['unitForm'].validate((valid) => {
          if (valid) {
              saveSignInfo(param).then(res => {
                  this_.loading = false;
                  if(res.code == 200){
                     Message.success('处理成功'); 
                     this_.$emit('close');
                  } else {
                     Message.error(res.msg);
                  }
              })
          } 
      });

    },

    //文件上传
    handleSuccessUpload(response, file){
      if(response.code == 200 && response.data != null){
          this.unitObj.fileId = response.data.fileId;
          this.unitObj.document = response.data.originalFilename;
      }
    }





  },
};
</script>

<style>
.znk_form_item {
  margin-bottom: 5px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/components/dialog/ServiceSignDialog.vue